export default __webpack_public_path__ + "static/media/link-account.76ece592.png";